/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useCallback, useRef, useLayoutEffect} from 'react';
import {
  TableDefault,
  TableAverage,
  ShadowTableColumn,
  ShadowTableHead,
  ShadowSummaryColumn,
  StickyMainHeader,
  StickyShadowMainHeader,
  StickySubHeader,
  ChangeContainer,
  ArrowDownContainer,
  ArrowHolderSummary,
  ColumnContainerSummary,
  LoadSpace,
  FeatureLocked,
  TitleFeatureLocked,
  TextFeatureLocked,
} from './styles';
import {SelectPlayerColumn} from '..';
import {GoArrowDown, GoChevronDown, GoChevronUp} from 'react-icons/go';
import {capitalizeFirstLetters} from '../../utils/hooks/text-formatter';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import {Popover} from '../popOver/Popover';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';

export default ({
  dataTableContent,
  dataAverage,
  filter,
  minWidth,
  dataCy,
  fatigueZone,
  hidePlayer,
  sortBy,
  sortOrder,
  handleSort,
}: {
  dataTableContent: Array<any>;
  dataAverage: object | any;
  minWidth: string;
  filter: string;
  dataCy?: string;
  fatigueZone?: boolean;
  hidePlayer?: any;
  sortBy: string;
  sortOrder: string;
  handleSort: (column: string) => void;
}) => {
  const [table, setTable] = useState<Array<any>>([]);
  const [popUp, usePopup] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setTable(dataTableContent);
  }, [dataTableContent]);

  function changeTable(e) {
    setTable([...e]);
  }

  function changeStatus(change) {
    // Downward arrows hidden per requirements - logic preserved
    // if (Math.trunc(change) < 0) {
    //   return (
    //     <ArrowDownContainer>
    //       <GoArrowDown size="10px" color="#fff" />
    //     </ArrowDownContainer>
    //   );
    // }
    return null;
  }

  function togglePopUp(selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
    } else {
      usePopup(selectedPopUp);
    }
  }

  function closeSorts() {
    usePopup('');
  }

  return (
    <TableDefault data-cy={dataCy} minWidth={minWidth}>
      <thead>
        <tr>
          <StickyMainHeader>HIDE</StickyMainHeader>
          <StickyMainHeader onClick={() => handleSort('playerName')} style={{cursor: 'pointer'}}>
            PLAYERS {sortBy === 'playerName' && (sortOrder === 'asc' ? '▲' : '▼')}
          </StickyMainHeader>
          <StickyShadowMainHeader onClick={() => handleSort('date')} style={{cursor: 'pointer'}}>
            DATE {sortBy === 'date' && (sortOrder === 'asc' ? '▲' : '▼')}
          </StickyShadowMainHeader>
          <StickyMainHeader colSpan={3}>EVENT</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>TOTAL ARC</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>INTERNAL ROTATION</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>EXTERNAL ROTATION</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>FLEXION</StickyMainHeader>
        </tr>
        <tr>
          <StickySubHeader />
          <StickySubHeader onClick={() => handleSort('playerName')} style={{cursor: 'pointer'}}>
            <ColumnContainerSummary>
              <span>Name</span>
              <ArrowHolderSummary>
                {sortBy === 'playerName' && sortOrder === 'asc' && <GoChevronUp size={14} />}
                {sortBy === 'playerName' && sortOrder === 'desc' && <GoChevronDown size={14} />}
              </ArrowHolderSummary>
            </ColumnContainerSummary>
          </StickySubHeader>
          <ShadowTableHead onClick={() => handleSort('date')} style={{cursor: 'pointer'}}>
            <ColumnContainerSummary>
              <span>Sort Date</span>
              <ArrowHolderSummary>
                {sortBy === 'date' && sortOrder === 'asc' && <GoChevronUp size={14} />}
                {sortBy === 'date' && sortOrder === 'desc' && <GoChevronDown size={14} />}
              </ArrowHolderSummary>
            </ColumnContainerSummary>
          </ShadowTableHead>
          <StickySubHeader onClick={() => handleSort('eventType')} style={{cursor: 'pointer'}}>
            <ColumnContainerSummary>
              <span>Type</span>
              <ArrowHolderSummary>
                {sortBy === 'eventType' && sortOrder === 'asc' && <GoChevronUp size={14} />}
                {sortBy === 'eventType' && sortOrder === 'desc' && <GoChevronDown size={14} />}
              </ArrowHolderSummary>
            </ColumnContainerSummary>
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_2')}>Pitches</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'event', 'pitches']}
              popup_id={'pu_2'}
              visible={popUp}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_3')}>RPE</span>
            <Popover table={dataTableContent} useTable={changeTable} data={['data', 'event', 'rpe']} popup_id={'pu_3'} visible={popUp} />
          </StickySubHeader>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_4')}>% Fresh</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'rom', 'freshTArcRatio']}
              popup_id={'pu_4'}
              visible={popUp}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_5')}>Change (°)</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'rom', 'freshTArcChange']}
              popup_id={'pu_5'}
              visible={popUp}
            />
          </ShadowTableHead>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_6')}>% Fresh</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'rom', 'freshIRRatio']}
              popup_id={'pu_6'}
              visible={popUp}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_7')}>Change (°)</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'rom', 'freshIRChange']}
              popup_id={'pu_7'}
              visible={popUp}
            />
          </StickySubHeader>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_8')}>% Fresh</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'rom', 'freshERRatio']}
              popup_id={'pu_8'}
              visible={popUp}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_9')}>Change (°)</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'rom', 'freshERChange']}
              popup_id={'pu_9'}
              visible={popUp}
            />
          </ShadowTableHead>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_10')}>% Fresh</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'rom', 'freshFlexionRatio']}
              popup_id={'pu_10'}
              visible={popUp}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_11')}>Change (°)</span>
            <Popover
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'rom', 'freshFlexionChange']}
              popup_id={'pu_11'}
              visible={popUp}
            />
          </StickySubHeader>
        </tr>
      </thead>
      <tbody onClick={() => closeSorts()}>
        {table.length > 0 && (
          <tr className="tr-average">
            <td style={{borderLeft: '7px solid var(--PrimaryBlue)'}} />
            <td>
              <TableAverage>
                <LoadSpace>{loading && <Loader width="20px" color="#B1D6FF" />}</LoadSpace>
                Team Average:
              </TableAverage>
            </td>
            <ShadowSummaryColumn />
            <td></td>
            <td></td>
            <td></td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.rom?.freshTArcRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              <ChangeContainer>
                <span> {numberColumnFormatter(dataAverage?.rom?.freshTArcChange, {digits: 0})}</span>
                {changeStatus(dataAverage?.rom?.totalARCTrend)}
              </ChangeContainer>
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.rom?.freshIRRatio, {digits: 0})}</td>
            <td>
              <ChangeContainer>
                <span>{numberColumnFormatter(dataAverage?.rom?.freshIRChange, {digits: 0})}</span>
                {changeStatus(dataAverage?.rom?.freshIRChange)}
              </ChangeContainer>
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.rom?.freshERRatio, {digits: 0})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              <ChangeContainer>
                <span>{numberColumnFormatter(dataAverage?.rom?.freshERChange, {digits: 0})}</span>
                {changeStatus(dataAverage?.rom?.freshERChange)}
              </ChangeContainer>
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.rom?.freshFlexionRatio, {digits: 0})}</td>
            <td>
              <ChangeContainer>
                <span> {numberColumnFormatter(dataAverage?.rom?.freshFlexionChange, {digits: 0})}</span>
                {changeStatus(dataAverage?.rom?.freshFlexionChange)}
              </ChangeContainer>
            </td>
          </tr>
        )}

        {table.length > 0 ? (
          table
            .filter(el => {
              const playerName: string = el?.player.firstName || '';
              const playerLast: string = el?.player.lastName || '';
              const name = `${playerName} ${playerLast}`;
              return name.toLocaleLowerCase().includes(filter.toLowerCase());
            })
            .map((item, index) => {
              item.data.alerts = item.data.alerts?.filter(alert => {
                if (alert === 'Pain') return true;
                else return false;
              });

              return (
                <TableItem
                  key={index}
                  item={item}
                  hidePlayer={hidePlayer}
                  fatigueZone={fatigueZone}
                  changeStatus={changeStatus}
                  setLoading={setLoading}
                />
              );
            })
        ) : (
          <tr>
            <td colSpan={25}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};

const TableItem = ({item, fatigueZone, changeStatus, hidePlayer, setLoading}) => {
  const [hide, setHide] = useState<Boolean>(item.player.excludeFromExamAvg);
  const [opacity, setOpacity] = useState<string>(item.player.excludeFromExamAvg ? '0.5' : '1');
  const PlayerRef = useRef(0) as any;
  const hiddenRef = useRef(0) as any;
  const dateRef = useRef(0) as any;
  /** defines where the component should start that limits the basic functionalities */
  const [left, setLeft] = useState<number>(340);

  useLayoutEffect(() => {
    changeScreen();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', changeScreen);

    return () => {
      window.removeEventListener('resize', changeScreen);
    };
  }, []);

  const changeScreen = () => {
    setLeft(hiddenRef.current.offsetWidth + PlayerRef.current.offsetWidth + dateRef.current.offsetWidth + 19);
  };

  const handleHideToggle = useCallback(() => {
    setHide(prevHide => {
      const newHide = !prevHide;
      hidePlayer(item.player._id, newHide ? 'exclude' : 'include');
      setLoading(true);
      hide ? setOpacity('0.5') : setOpacity('1');
      return newHide;
    });
  }, [hidePlayer, item.player._id, setLoading]);

  return (
    <tr style={{opacity: opacity, position: 'relative'}}>
      <td className="white pointer" onClick={handleHideToggle} ref={hiddenRef}>
        {hide ? <img src={HideOn} alt="hideOn" /> : <img src={HideOff} alt="hideOff" />}
      </td>
      <SelectPlayerColumn player={item.player} padding={'8px'} PlayerColumnRef={PlayerRef} />
      <ShadowTableColumn ref={dateRef}>
        {(item.data.date && new Date(item.data.date).toLocaleDateString('en-US')) || '-'}
      </ShadowTableColumn>
      <td className="white">{item.player.plan !== 'basic' && capitalizeFirstLetters(item?.data?.event?.type, '_')}</td>
      <td className="white">
        {item.player.plan !== 'basic' && item?.data?.event?.type === 'velo_day'
          ? item?.data?.event?.highIntentsThrows
          : numberColumnFormatter(item?.data?.event?.pitches, {digits: 0})}
      </td>
      <td className="white">{(item.player.plan !== 'basic' && item?.data?.event?.rpe) || '-'}</td>
      <ShadowTableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.rom.freshTArcRatio, {digits: 0})}
      </ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.rom.freshTArcChange, {digits: 0})}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.rom?.freshTArcChange)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white">{item.player.plan !== 'basic' && numberColumnFormatter(item.data.rom?.freshIRRatio, {digits: 0})}</td>
      <td className="white">
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.rom.freshIRChange, {digits: 0})}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.rom?.freshIRChange)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.rom?.freshERRatio, {digits: 0})}
      </ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.rom?.freshERChange, {digits: 0})}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.rom?.freshERChange)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white">{item.player.plan !== 'basic' && numberColumnFormatter(item.data.rom?.freshFlexionRatio, {digits: 0})}</td>
      <td className="white">{item.player.plan !== 'basic' && numberColumnFormatter(item.data.rom?.freshFlexionChange, {digits: 0})}</td>
      {item.player.plan === 'basic' && (
        <FeatureLocked left={left} right={19}>
          <TitleFeatureLocked>
            Basic Subscription
            <TextFeatureLocked>
              {' '}
              - Unlock this data by sponsoring the athlete or have the player purchase a premium subscription
            </TextFeatureLocked>
          </TitleFeatureLocked>
        </FeatureLocked>
      )}
    </tr>
  );
};
